export default {
  assetsBidInfos: []
};
